import type { EChartsCoreOption } from 'echarts/core';

import {
  DataInterval,
  ReportsCategoryAxisOptions,
  ReportsTimeAxisOptions,
} from '@core/reports-types';

import { createChartMediaQueryRules } from '../media-query';
import { getBoundaryGap } from './boundary-gap';
import { formatSingleTickAxisLabel } from './date-format';

// eslint-disable-next-line max-lines-per-function
export const monthly = (
  ticksCount: number,
): {
  xAxis: ReportsCategoryAxisOptions | ReportsTimeAxisOptions;
  media: EChartsCoreOption['media'];
} => {
  const singleTickAxis = ticksCount === 1;
  const boundaryGap = getBoundaryGap(ticksCount);

  const formatterOpts = singleTickAxis
    ? formatSingleTickAxisLabel(DataInterval.Monthly)
    : {
        day: '{MMM}',
        month: '{MMM}',
        year: '{level1|{MMM}\n{yyyy}}',
        inherit: false,
      };

  return {
    xAxis: {
      type: singleTickAxis ? 'category' : 'time',
      boundaryGap,
      showMinLabel: false,
      showMaxLabel: false,
      axisLabel: {
        formatter: formatterOpts,
        fontSize: 12,
        rich: {
          primary: {
            top: 30,
          },
          level1: {
            fontWeight: 'bold',
          },
        },
      },
    },
    media: createChartMediaQueryRules([
      {
        minW: 0,
        maxW: 300,
        opts: {
          xAxis: {
            splitNumber: Math.max(1, Math.min(ticksCount, 4)),
            axisLabel: {
              hideOverlap: true,
            },
          },
        },
      },
      {
        minW: 300,
        maxW: 400,
        opts: {
          xAxis: {
            splitNumber: Math.max(1, Math.min(ticksCount, 6)),
          },
        },
      },
      {
        minW: 400,
        maxW: 620,
        opts: {
          xAxis: {
            splitNumber: Math.max(1, Math.min(ticksCount, 10)),
          },
        },
      },
      {
        minW: 620,
        maxW: 1050,
        opts: {
          xAxis: {
            splitNumber: Math.max(1, Math.min(ticksCount, 18)),
          },
        },
      },
      {
        minW: 1050,
        maxW: Number.POSITIVE_INFINITY,
        opts: {
          xAxis: {
            splitNumber: Math.max(1, Math.min(ticksCount, 26)),
          },
        },
      },
    ]),
  };
};
